import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './pages/search/search.component';
import {SearchRoutingModule} from './search-routing.module';
import {GlobalSearchbarComponent} from './components/global-searchbar/global-searchbar.component';
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {SharedModule} from '@app/shared';
import {ReactiveFormsModule} from '@angular/forms';
import {NzInputDirective} from 'ng-zorro-antd/input';
import { GlobalSearchResultsComponent } from './components/global-search-results/global-search-results.component';
import { GlobalSearchResultCardComponent } from './components/global-search-result-card/global-search-result-card.component';
import {NzButtonComponent} from "ng-zorro-antd/button";
import {NzBreadCrumbComponent, NzBreadCrumbItemComponent} from "ng-zorro-antd/breadcrumb";
import {NzContentComponent, NzLayoutComponent, NzSiderComponent} from "ng-zorro-antd/layout";
import {NzPageHeaderComponent, NzPageHeaderExtraDirective} from "ng-zorro-antd/page-header";
import {NzSkeletonComponent} from "ng-zorro-antd/skeleton";



@NgModule({
  declarations: [
    SearchComponent,
    GlobalSearchbarComponent,
    GlobalSearchResultsComponent,
    GlobalSearchResultCardComponent
  ],
    imports: [
        CommonModule,
        SearchRoutingModule,
        NzDividerComponent,
        SharedModule,
        ReactiveFormsModule,
        NzInputDirective,
        NzButtonComponent,
        NzBreadCrumbComponent,
        NzBreadCrumbItemComponent,
        NzContentComponent,
        NzLayoutComponent,
        NzPageHeaderComponent,
        NzPageHeaderExtraDirective,
        NzSiderComponent,
        NzSkeletonComponent
    ],
  exports: [
    GlobalSearchbarComponent
  ]
})
export class SearchModule { }
